export const pages = {
	'boltHubPage': { id: 'boltHubPage', page: 'home', getter: () => import(/* webpackChunkName: 'boltHubPage' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltHubPage', getter: () => import(/* webpackChunkName: "boltHubPage" */ 'components/bolt/hub/hub'), component: 'hub' },
	{ id: 'about', getter: () => import(/* webpackChunkName: "about" */ 'components/bolt/text/text'), component: 'text' }
];
export const sectionsWithParent = [

];
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
